import React from 'react'
import { Button, Icon } from 'antd-mobile'
import './index.scss'
interface Props {
  title: string
  desc: string
  tip?: string
  cancelText?: string
  confirmText?: string
  cancelFun?: any
  confirmFun?: any
  closeFun?: any
}

function CommonModal({ title, desc, tip, cancelText, confirmText, cancelFun, confirmFun, closeFun }: Props) {
  return (
    <div className='c-modal-wrap'>
      <div className='mask-layer'>
        <span className='btn-close' onClick={closeFun}>
          <Icon type='cross-circle' size='md' color='#fff' />
        </span>
      </div>
      <div className='modal-content'>
        <p className='modal-title'>{title}</p>
        <div className='modal-body'>
          <div className='desc'>{desc}</div>
          <div className='tip'>{tip}</div>
        </div>
        {(confirmText || cancelText) && (
          <div className='modal-footer'>
            {cancelText && (
              <Button className={`btn btn-cancel ${!confirmText ? 'btn-single' : ''}`} onClick={cancelFun}>
                {cancelText}
              </Button>
            )}
            {confirmText && (
              <Button className={`btn btn-confirm ${!cancelText ? 'btn-single' : ''}`} onClick={confirmFun}>
                {confirmText}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default CommonModal
